import Misc from 'src/utils/helper/misc'
export default {
  filterModalErrors (idx) {
    const modalErrors = this.modalErrors.filter(item => item.id !== idx)
    this.modalErrors = modalErrors
  },
  nextick (renderFunc, ref) {
    this.$nextTick(() => {
      renderFunc(ref)
    })
  },
  redirectMethod() {
    const mailtoLink = 'mailto:foundrysupport@monotype.com';
    window.open(mailtoLink, '_blank');
  },
  renderModal (reference) {
    this.modalOptions.cols = reference?.cols
    this.modalOptions.content = reference?.$slots?.content?.()
    this.show(this.modalOptions)
  },
  newBinariesPsError () {
    const newPsNames = this.updateModalData.map(val => val.newBinary.psName)
    const newPsSize = newPsNames.length
    const uniqueNewPsName = Misc.removeDuplicates(newPsNames)
    const uniqueNewPsSize = uniqueNewPsName.length
    if (newPsSize !== uniqueNewPsSize) {
      const msgId = 5
      const msg = this.$t('pages.submissions.components.menue.live_modal_update.error.id5')
      const psNewBinaryError = Misc.getModalErrorObj(msgId, msg)
      const isError = Misc.isObjExists(psNewBinaryError, this.modalErrors)
      if (!isError) {
        this.modalErrors.push(psNewBinaryError)
      }
    } else {
      this.filterModalErrors(5)
    }
  },
  updateLiveSubmission () {
    this.isAllLabelsSelected()
    this.isMultipleSelection()
    this.newBinariesPsError()
    if (this.modalErrors.length === 0) {
      const binaryMapper = this.oldNewBinaryMapper()
      this.isUpdateModal = false
      this.updateModalData = []
      this.$events.$emit('remove:binary', binaryMapper)
    }
  },
  selectFont () {
    this.clearErrorId2()
    this.isMultipleSelection()
    this.samePsError()
  },
  clearErrorId2 () {
    const selectValues = this.selectedLabels.filter(i => i === 'select')
    if (selectValues.length === 0) {
      this.isAllLabelsSelected()
    }
  },
  isAllLabelsSelected () {
    const isSelected = this.selectedLabels.some((data) => data === 'select')
    if (isSelected) {
      const msgId = 2
      const msg = this.$t('pages.submissions.components.menue.live_modal_update.error.id2')
      const notSelectError = Misc.getModalErrorObj(msgId, msg)
      const isError = Misc.isObjExists(notSelectError, this.modalErrors)
      if (!isError) {
        this.modalErrors.push(notSelectError)
      }
    } else {
      this.filterModalErrors(2)
    }
    this.nextick(this.renderModal, this.$refs.updateModal)
  },
  oldNewBinaryMapper () {
    const oldNewBinaryMapper = this.selectedLabels.filter(data => data !== 'select').map((value, key) => {
      const index = Misc.findIndex(this.updateModalData[key].releasedBinaries, { binaryId: value })
      const newBId = this.updateModalData[key].newBinary.id
      const newPsName = this.updateModalData[key].newBinary.psName
      const oldPsName = this.updateModalData[key].releasedBinaries[index].psName
      return {
        newBId,
        newPsName,
        oldMappedBId: value,
        oldPsName
      }
    })
    return oldNewBinaryMapper
  },
  isMultipleSelection () {
    const filterLabel = this.selectedLabels.filter((item) => item !== 'select' && item !== 'add' && item !== 'n/s')
    const uniqueSelectedSize = Misc.removeDuplicates(filterLabel).length
    const selectedLabelsSize = filterLabel.length
    if (uniqueSelectedSize !== selectedLabelsSize) {
      const msgId = 3
      const msg = this.$t('pages.submissions.components.menue.live_modal_update.error.id3')
      const multiSelectError = Misc.getModalErrorObj(msgId, msg)
      const isError = Misc.isObjExists(multiSelectError, this.modalErrors)
      if (!isError) {
        this.modalErrors.push(multiSelectError)
      }
    } else {
      this.filterModalErrors(3)
    }
    this.nextick(this.renderModal, this.$refs.updateModal)
  },
  isSamePsExistError () {
    const newPsNames = this.updateModalData.map(val => val.newBinary.psName)
    const selectedPsNames = []
    const existingPsNames = []
    this.selectedLabels.map((val, key) => {
      const existingPsName = this.updateModalData[key].releasedBinaries.map((item) => item.psName)
      existingPsNames.push(existingPsName)
      const index = Misc.findIndex(this.updateModalData[0].releasedBinaries, { binaryId: val })
      if (index > -1) {
        const selectedPsName = this.updateModalData[key].releasedBinaries[index].psName
        selectedPsNames.push(selectedPsName)
      }
    })
    let isPsExists = false
    for (let i = 0; i < this.selectedLabels.length; i++) {
      if (newPsNames[i] !== selectedPsNames[i]) {
        if (selectedPsNames.filter(it => it === newPsNames[i]).length === 0) {
          const z = existingPsNames[i].filter(at => at === newPsNames[i])
          if (z.length > 0) {
            isPsExists = true
          }
        }
      }
    }
    return isPsExists
  },
  samePsError () {
    const isErrors = this.isSamePsExistError()
    if (isErrors) {
      const msgId = 4
      const msg = this.$t('pages.submissions.components.menue.live_modal_update.error.id4')
      const samePsExistError = Misc.getModalErrorObj(msgId, msg)
      const isError = Misc.isObjExists(samePsExistError, this.modalErrors)
      if (!isError) {
        this.modalErrors.push(samePsExistError)
      }
    } else {
      this.filterModalErrors(4)
    }
    this.nextick(this.renderModal, this.$refs.updateModal)
  }
}
